import {
  APP_LOCALE_LABELS,
  APP_LOCALES,
  getLocale,
  setLocale,
  subscribeLocaleChange,
  type AppLocale,
} from "./i18n/locale-state";

type LocaleStorageAdapter = {
  getStoredLocale: () => AppLocale;
  setStoredLocale: (locale: string) => AppLocale;
};

function updateDocumentLanguage(locale: AppLocale) {
  if (typeof document !== "undefined") {
    document.documentElement.lang = locale;
  }
}

export const localeOptions = APP_LOCALES.map((value) => ({
  value,
  label: APP_LOCALE_LABELS[value],
}));

export function initializeLocale(getStoredLocale: () => AppLocale) {
  const locale = setLocale(getStoredLocale());
  updateDocumentLanguage(locale);
  return locale;
}

export function switchLocale(locale: string, setStoredLocale: (locale: string) => AppLocale) {
  const nextLocale = setStoredLocale(locale);
  setLocale(nextLocale);
  updateDocumentLanguage(nextLocale);
  return nextLocale;
}

export function createLocaleController(adapter: LocaleStorageAdapter) {
  return {
    localeOptions,
    initializeLocale: () => initializeLocale(adapter.getStoredLocale),
    switchLocale: (locale: string) => switchLocale(locale, adapter.setStoredLocale),
    getLocaleSnapshot: getLocale,
    subscribeLocaleChange,
  };
}
